import { ref, computed } from "vue";
import { useStore } from "vuex";
import FormInputTextField from "../FormInputTextField/FormInputTextField";
import FormInputTextarea from "../FormInputTextarea/FormInputTextarea";
import FormInputDropdown from "../FormInputDropdown/FormInputDropdown";
import FormInputEmailField from "../FormInputEmailField/FormInputEmailField";
import FormCheckbox from "../FormCheckbox/FormCheckbox";
import FormInputNameField from "../FormInputNameField/FormInputNameField";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import DropdownWithTags from "../DropdownWithTags/DropdownWithTags";
import nameValidator from "foundation/js/inputValidators/nameValidator";
import nonEmptyStringValidator from "foundation/js/inputValidators/nonEmptyStringValidator";
import isBoolean from "foundation/js/inputValidators/isBoolean";

export default {
    name: "ForumEditProfile",
    components: {
        FormInputTextField,
        FormInputTextarea,
        FormInputNameField,
        FormInputEmailField,
        FormInputDropdown,
        FormCheckbox,
        ProfilePicture,
        DropdownWithTags
    },
    props: {
        content: {
            type: Object,
            required: true,
        },
        continueUrl: {
            type: String,
            required: true,
        },
        continueUrlWithData: {
            type: String,
            required: true,
        }
    },
    setup(props) {
        const store = useStore();
        const personalInfo = ref({
            ProfileName: props.content.memberName ?? "",
            relationToCancer: props.content.memberRoles === "" ? null : props.content.memberRoles,
            cancerType: props.content.memberDiagnosis ?? [""],
            cancerTypeChanged: [""],
            region: props.content.memberRegion === "" ? null : props.content.memberRegion,
            dateOfBirth: props.content.memberDateOfBirth,
            gender: props.content.memberGender ?? "",
            description: props.content.memberProfileText ?? "",
            NotificationForNewPostInMyGroups: props.content.notifications.postInGroup ?? false,
            NotificationForDirectMessage: props.content.notifications.privateMessage ?? false,
            NotificationForCommentOnMySavedPosts: props.content.notifications.commentOnMyPost ?? false,
            NotificationForNewCommentInMyGroups: props.content.notifications.commentInMyGroups ?? false,
            NotificationFrequency: props.content.notifications.frequency,
        });
        const notificationfrequencyOptions = [
            { "name": "Straks", "value": "Immediately" },
            { "name": "Dagligt", "value": "Daily" },
            { "name": "Ugentligt", "value": "Weekly" },
        ]
        const genderOptions =[
            { "name": "Kvinde", "value": "Kvinde"},
            { "name": "Mand", "value": "Mand" },
            { "name": "Andet", "value": "Andet" }
        ]

        const hasProfilePicture = ref(props.content.hasProfileImage === "true")
        const activeProfilePicture = ref({
            "name": props.content.memberImgName ?? "",
            "url": props.content.memberImgSrc ?? "",
            "size": props.content.memberImgSize ?? ""
        })

        const changePasswordUrl = props.content.changePasswordUrl

        const displayError = ref(false)
        const isSubmitting = computed(()=> store.state.forum.is_submitting)

        const isFormValid = () => {
            return nameValidator(personalInfo.value.ProfileName) &&
                isBoolean(personalInfo.value.NotificationForNewPostInMyGroups) &&
                isBoolean(personalInfo.value.NotificationForDirectMessage) &&
                isBoolean(personalInfo.value.NotificationForCommentOnMySavedPosts) &&
                nonEmptyStringValidator(personalInfo.value.NotificationFrequency)
        };

        const saveProfile = () => {
            const isValid = isFormValid()
            displayError.value = !isValid; 

            if (!isValid) {
                return
            }

            if (!personalInfo.value.dateOfBirth) {
                personalInfo.value.dateOfBirth = null
            }

            store.dispatch('forum/submitSaveProfile', {
                body: personalInfo.value
            })
        };

        const startDeleteUserOverlay = function (e) {
            store.commit('main/set_page_overlay_content_data', { cancerforumProfileId: props.content.id, continueUrl: props.continueUrl, continueUrlWithData: props.continueUrlWithData })
 
            store.dispatch("main/openPageOverlay", {
                overlayContent: "DeleteCancerProfileModal",
                returnTarget: e.currentTarget,
            });
        };

        const startUserInfoOverlay = function (e) {
            store.dispatch("main/openPageOverlay", {
                overlayContent: "MemberOverlay",
                returnTarget: e.currentTarget,
            });
        };

        const setCancerTypes = function(tags) {
            personalInfo.value.cancerType = tags
        }

        return {
            notificationfrequencyOptions,
            genderOptions,
            hasProfilePicture,
            activeProfilePicture,
            personalInfo,
            changePasswordUrl,
            saveProfile,
            nameValidator,
            nonEmptyStringValidator,
            startDeleteUserOverlay,
            displayError,
            isSubmitting,
            setCancerTypes,
            startUserInfoOverlay,
            getLabel: (labelKey) =>
                store.getters["labels/getLabel"]({
                    labelCollection: "ForumEditProfile",
                    labelKey,
                }),
        };
    },
};
